module.exports = __webpack_public_path__ + "img/home2.1e4613e3.png";